import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { enumAttributeConverter } from '../enum-types';
import { GlowingPlaceholderTypes } from './placeholders.enums';

import * as PlaceholderTags from './placeholders.tagnames';
import { AtlGlowingPlaceholderProps } from './placeholders.props';

@customElement(PlaceholderTags.Glowing)
export class AtlGlowingPlaceholder extends LitElement implements AtlGlowingPlaceholderProps {

    declare type: GlowingPlaceholderTypes;

    static properties = {
        type: { type: String, converter: enumAttributeConverter(GlowingPlaceholderTypes)  }
    }

    static styles = [
        css`::slotted(*) {
            animation: placeholder-glow 2s ease-in-out infinite;
        }`,
    ];

    render() {
        switch (this.type) {
            case GlowingPlaceholderTypes.Span:
                return html`<span class="placeholder-glow"><slot></slot></span>`;
            case GlowingPlaceholderTypes.Paragraph:
                return html`<p class="placeholder-glow"><slot></slot></p>`;
            default:
                return html`<div class="placeholder-glow"><slot></slot></div>`;
        }
    }
}